/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AsName1 } from './AsName1';
import {
    AsName1FromJSON,
    AsName1FromJSONTyped,
    AsName1ToJSON,
} from './AsName1';
import type { Category1 } from './Category1';
import {
    Category1FromJSON,
    Category1FromJSONTyped,
    Category1ToJSON,
} from './Category1';

/**
 * 
 * @export
 * @interface ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet
 */
export interface ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet {
    /**
     * 
     * @type {Category1}
     * @memberof ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet
     */
    category?: Category1;
    /**
     * 
     * @type {AsName1}
     * @memberof ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet
     */
    as_name?: AsName1;
}

/**
 * Check if a given object implements the ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet interface.
 */
export function instanceOfControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGetFromJSON(json: any): ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet {
    return ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGetFromJSONTyped(json, false);
}

export function ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': !exists(json, 'category') ? undefined : Category1FromJSON(json['category']),
        'as_name': !exists(json, 'as_name') ? undefined : AsName1FromJSON(json['as_name']),
    };
}

export function ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGetToJSON(value?: ControlBodyGetEntityAssetsAsmEntityEntityIdAssetsGet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': Category1ToJSON(value.category),
        'as_name': AsName1ToJSON(value.as_name),
    };
}

